import React, { useEffect, useState } from "react";
import { GET, PGET } from "../../../api/adminApi";
import CustomDatePicker from "../../common/CustomDatePicker";
import moment from "moment/moment";
import Select from "react-select";
import { get } from "lodash";

export default function ProductSales() {
  const [items, setItems] = useState([]);
  const [dateRange, setDateRange] = useState([
    new Date("2026-01-01"),
    new Date("2027-01-01"),
  ]);
  const [selectedOption, setSelectedOption] = useState({
    label: "Секционный",
    value: 1,
  });
  const [trademarks, setTrademarks] = useState([]);
  const [trademark, setTrademark] = useState(trademarks[0]);
  const [startDate, endDate] = dateRange;

  async function getTrademarks() {
    const response = await GET(
      `/services/admin/api/product-trademark-helper/${selectedOption.value}`
    );

    if (response.length > 0) {
      setTrademarks(response);
    }
  }

  async function getItems() {
    if (startDate && endDate) {
      const data = await PGET(
        "/services/admin/api/dashboard-products-sales/",
        true,
        {
          dateFrom: moment(startDate).format("YYYY-MM-DD"),
          dateTo: moment(endDate).add(0, "day").format("YYYY-MM-DD"),
          category: selectedOption.value,
          trademark: get(trademark, "trademarkId", 125004),
        }
      );
      if (data) {
        setItems(data.data);
      }
    }
  }

  const selectTrademark = (selectedOpt) => {
    if (trademark !== selectedOpt) {
      setTrademark(selectedOpt);
    }
  };

  const handleChange = (selected) => {
    setSelectedOption(selected);
    setTrademark([]);
  };

  const options = [
    { label: "Секционный", value: 1 },
    { label: "Панельный", value: 2 },
    { label: "Котел", value: 3 },
  ];

  useEffect(() => {
    getTrademarks();
  }, [selectedOption]);

  useEffect(() => {
    getItems();
  }, [startDate, endDate, selectedOption, trademark]);

  return (
    <div className="pb-4" style={{ minHeight: 400 }}>
      <div style={{ width: 200, position: "absolute", right: 340, top: 15 }}>
        <CustomDatePicker
          startDate={startDate}
          endDate={endDate}
          onChange={(update) => {
            setDateRange(update);
          }}
          className="datepicker-custom-input-dash !h-[36px]"
        />
      </div>
      <div style={{ width: 200, position: "absolute", right: 130, top: 15 }}>
        <Select
          name="regionId"
          className="custom-react-select"
          options={options}
          value={selectedOption}
          style={{ height: 30 }}
          onChange={handleChange}
        />
      </div>
      <div style={{ width: 200, position: "absolute", right: 0, top: 15 }}>
        <Select
          name="tradeId"
          className="custom-react-select"
          options={trademarks}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.trademarkId}
          value={trademark}
          style={{ height: 30 }}
          onChange={selectTrademark}
        />
      </div>
      <div style={{ overflowX: "auto" }}>
        <table
          className="table bg-white table-rounded table-striped"
          style={{ fontSize: 12 }}
        >
          <thead>
            <tr className="text-gray-800 border-gray-200 fw-bold border-bottom-2">
              <th style={{ width: "30px" }} className="text-center">
                №
              </th>
              <th className="text-start">Название продукта</th>
              <th className="text-end">Кол-во в упаковке</th>
              <th className="text-center">Кол-во продаж</th>
            </tr>
          </thead>

          <tbody style={{ overflowX: "auto" }}>
            {items.map((item, index) => {
              return (
                <tr key={item.id}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-start">{item.productName}</td>
                  <td className="text-end">
                    {item.sectionCount.toLocaleString("ru-Ru")}
                  </td>
                  <td className="text-center">
                    {item.soldCount.toLocaleString("ru-Ru")}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
